import { Star } from "lucide-react";

export const Stars = ({ rating = 0, size = "w-4 h-4", testId }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testId} aria-label={`${rating} out of 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= Math.round(rating) ? "text-amber-400 fill-amber-400" : "text-slate-300"}`} />
    ))}
  </span>
);

export const RatingBadge = ({ rating, count, testId }) => (
  count > 0 ? (
    <span className="inline-flex items-center gap-1 font-body text-xs text-slate-600" data-testid={testId}>
      <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" />
      <span className="font-semibold text-slate-900">{Number(rating).toFixed(1)}</span>
      <span className="text-slate-400">({count})</span>
    </span>
  ) : null
);

export const ReviewAvatar = ({ r, className = "w-11 h-11" }) => (
  r.photo ? <img src={r.photo} alt={r.name} className={`${className} rounded-full object-cover shrink-0`} />
    : <div className={`${className} rounded-full bg-primary/10 text-primary flex items-center justify-center font-heading font-bold text-sm shrink-0`}>{r.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}</div>
);

export const ReviewCard = ({ r, showMentor = false }) => (
  <article className="bg-white rounded-3xl border border-slate-200 p-6 flex flex-col" data-testid={`review-${r.review_id}`}>
    <Stars rating={r.rating} />
    <p className="font-body text-base text-slate-700 mt-3 leading-relaxed flex-1">“{r.text}”</p>
    <div className="flex items-center gap-3 mt-5 pt-4 border-t border-slate-100">
      <ReviewAvatar r={r} />
      <div className="min-w-0">
        <p className="font-heading font-bold text-sm text-slate-900 truncate">{r.name}</p>
        <p className="font-body text-xs text-slate-500 truncate">{r.role}{showMentor && r.mentor_name ? ` · mentored by ${r.mentor_name}` : ""}</p>
      </div>
    </div>
  </article>
);
